<template>
    <div :class="`Note Note--${backgroundColor}`">
        <div class="Note__header">
            <div class="Note__header-title">
                <span class="Note__user">{{ note.user }}</span>
                <span
                    v-if="note.type === 'note'"
                    class="Note__status"
                >added a note</span>
            </div>
            <div class="Note__date-time">
                {{ noteDateTime }}
            </div>
        </div>
        <div
            v-if="note.type === 'activity'"
            class="Note__activity-container"
        >
            <span class="Note__activity-text">Response status was changed to </span>
            <RPResponsePill
                :status="note.status_after.toLowerCase()"
            />
        </div>
        <div
            v-if="note.note"
            :class="noteContainerClass"
        >
            {{ note.note }}
        </div>
    </div>
</template>
<script>
import RPResponsePill from 'components/Complex/Pills/RPResponsePill.vue';
import moment from 'moment';
import has from 'lodash/has';
export default {
    name: 'Note',
    components: {
        RPResponsePill,
    },
    props: {
        backgroundColor: {
            type: String,
            default: 'white'
        },
        note: {
            type: Object,
            required: true,
        }
    },
    computed: {
        noteDateTime(){
            return moment(this.note.date, 'YYYY-MM-DD HH:mm:ss').format('MMM DD, YYYY [at] HH:mm');
        },
        noteContainerClass(){
            let c = 'Note__note-container';
            if(has(this.note, 'status')) {
                c += `Note__note-container--${this.note.status}}`;
            }
            return c;
        }
    }
};
</script>
<style lang="scss">
    .Note {
        padding: 1rem;
        font-size: 0.85rem;
        &--white{
            background: $white;
        }
        &--grey{
            background: $grey-50;
        }
        &__header{
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        &__header-title{
            display: flex;
            align-items: center;
        }
        &__user {
            font-weight: 600;
            margin-right: 0.25rem;
        }
        &__status {
            display: flex;
            align-items: center;
        }
        &__status-text{
            margin-right: 0.25rem;
        }
        &__activity-container {
            margin-top: 0.25rem;
            display: flex;
            align-items: center;
        }
        &__activity-text {
            margin-right: 0.25rem;
        }
        &__note-container {
            margin-top: 1rem;
            border-left: 2px solid $highlight-blue;
            padding-left: 0.5rem;
            color: $text-grey;
            &--onHold {
                border-left-color: $warning-yellow;
            }
            &--approved {
                border-left-color: $success-green;
            }
            &--rejected {
                border-left-color: $error-red;
            }
            &--posted {
                border-left-color: $success-green;
            }
        }
    }
</style>
